// extracted by mini-css-extract-plugin
export var box_01 = "box-01-module--box_01--9KrRA";
export var __link = "box-01-module--__link--3_w-c";